import { z } from "zod";

import { ESitePhotoOcrResultStatus } from "@/types/backoffice/dto/photo/site-photo-dto.ts";

export const patchSiteDocumentOcrResultStatusSchema = z.union([
  z.literal(ESitePhotoOcrResultStatus.OK),
  z.literal(ESitePhotoOcrResultStatus.KO),
]);

export const patchSiteDocumentMetadataDtoSchema = z.object({
  ocrResultStatus: patchSiteDocumentOcrResultStatusSchema,
});

export type PatchSiteDocumentMetadataDto = z.infer<typeof patchSiteDocumentMetadataDtoSchema>;
